:root {
  --cbp-icon-color: currentColor;
  --cbp-icon-size: 1rem;
}
cbp-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: text-top;

  svg {
    width: var(--cbp-icon-size);
    height: var(--cbp-icon-size);
    fill: var(--cbp-icon-color);
    vertical-align: top;
  }
}
